export const chatFlowData = {
  // ─── LANGUAGE SELECTION ──────────────────────────────────────────────────────
  languageSelect: {
    message: 'Hello! Welcome to Jairam Yoga 🙏\nPlease select your preferred language.',
    hindi_message: 'नमस्ते! Jairam Yoga में आपका स्वागत है 🙏\nकृपया अपनी भाषा चुनें।',
    options: [
      { label: 'English', hindi_label: 'English', nextNode: 'welcome' },
      { label: 'हिंदी', hindi_label: 'हिंदी', nextNode: 'welcome' },
    ],
  },

  welcome: {
    message: 'Welcome to Jairam Yoga! 🙏 How may I help you today?',
    hindi_message: 'Jairam Yoga में आपका स्वागत है! 🙏 आज मैं आपकी कैसे मदद कर सकता हूँ?',
    options: [
      {
        label: 'Weight Loss Classes',
        hindi_label: 'वजन घटाने की क्लासेस',
        nextNode: 'showCourseswlc',
      },
      {
        label: 'Health Issues Classes',
        hindi_label: 'स्वास्थ्य समस्याओं की क्लासेस',
        nextNode: 'healthIssuesList',
      },
      { label: 'Lifestyle Improvement (Fitness Classes)', hindi_label: 'जीवनशैली सुधार', nextNode: 'showCoursesli' },
      { label: 'Any Other Query', hindi_label: 'कोई और सवाल', nextNode: 'displayFormB' },
    ],
  },

  // ─── FORM NODES ─────────────────────────────────────────────────────────────

  displayFormB: {
    message: 'Fill out this form and our team will reach out to you soon',
    hindi_message: 'यह फॉर्म भरें और हमारी टीम जल्द ही आपसे संपर्क करेगी',
    showForm: true,
    options: [],
    formConfig: {
      formId: 'generalQuery',
      title: 'General Query Form',
      hindi_title: 'सामान्य सवाल फॉर्म',
      submitLabel: 'Submit Query',
      hindi_submitLabel: 'सवाल भेजें',
      afterSubmitNode: 'formSubmitThankYou',
      fields: [
        {
          name: 'name',
          label: 'Name',
          hindi_label: 'नाम',
          type: 'text',
          placeholder: 'Enter your name',
          hindi_placeholder: 'अपना नाम लिखें',
          validation: { required: true },
        },
        {
          name: 'phone',
          label: 'Phone Number',
          hindi_label: 'फोन नंबर',
          type: 'tel',
          placeholder: 'Enter 10-digit phone number',
          hindi_placeholder: '10 अंकों का फोन नंबर लिखें',
          validation: {
            required: true,
            pattern: /^\d{10}$/,
            patternMessage: 'Enter a valid 10-digit phone number',
            hindi_patternMessage: 'सही 10 अंकों का फोन नंबर लिखें',
          },
        },
        {
          name: 'city',
          label: 'City',
          hindi_label: 'शहर',
          type: 'text',
          placeholder: 'Enter your city',
          hindi_placeholder: 'अपना शहर लिखें',
          validation: { required: true },
        },
        {
          name: 'message',
          label: 'Message',
          hindi_label: 'संदेश',
          type: 'text',
          placeholder: 'Describe your query',
          hindi_placeholder: 'अपना सवाल लिखें',
          validation: { required: true },
        },
      ],
    },
  },

  noHealthIssueForm: {
    message: 'Please fill out the form below and our team will reach out to you soon:',
    hindi_message: 'कृपया नीचे दिया फॉर्म भरें, हमारी टीम जल्द आपसे बात करेगी:',
    showForm: true,
    options: [],
    formConfig: {
      formId: 'noHealthIssue',
      title: 'Personal Details',
      hindi_title: 'आपकी जानकारी',
      submitLabel: 'Submit',
      hindi_submitLabel: 'जमा करें',
      afterSubmitNode: 'paymentNode',
      fields: [
        {
          name: 'name',
          label: 'Name',
          hindi_label: 'नाम',
          type: 'text',
          placeholder: 'Enter your name',
          hindi_placeholder: 'अपना नाम लिखें',
          validation: { required: true },
        },
        {
          name: 'age',
          label: 'Age',
          hindi_label: 'उम्र',
          type: 'number',
          placeholder: 'Enter your age',
          hindi_placeholder: 'अपनी उम्र लिखें',
          validation: {
            required: true,
            min: 1,
            minMessage: 'Enter a valid age',
            hindi_minMessage: 'सही उम्र लिखें',
          },
        },
        {
          name: 'height',
          label: 'Height (cm)',
          hindi_label: 'लंबाई (cm)',
          type: 'text',
          placeholder: 'e.g. 165',
          hindi_placeholder: 'जैसे 165',
          validation: { required: true },
        },
        {
          name: 'weight',
          label: 'Weight (kg)',
          hindi_label: 'वजन (kg)',
          type: 'text',
          placeholder: 'e.g. 70',
          hindi_placeholder: 'जैसे 70',
          validation: { required: true },
        },
        {
          name: 'city',
          label: 'City',
          hindi_label: 'शहर',
          type: 'text',
          placeholder: 'Enter your city',
          hindi_placeholder: 'अपना शहर लिखें',
          validation: { required: true },
        },
        {
          name: 'phone',
          label: 'Phone Number',
          hindi_label: 'फोन नंबर',
          type: 'tel',
          placeholder: 'Enter 10-digit phone number',
          hindi_placeholder: '10 अंकों का फोन नंबर लिखें',
          validation: {
            required: true,
            pattern: /^\d{10}$/,
            patternMessage: 'Enter a valid 10-digit phone number',
            hindi_patternMessage: 'सही 10 अंकों का फोन नंबर लिखें',
          },
        },
      ],
    },
  },

  // ─── PAYMENT NODE ────────────────────────────────────────────────────────────

  paymentNode: {
    message: 'Great! You are one step away from starting your journey. 🧘',
    hindi_message: 'बढ़िया! आप अपनी journey शुरू करने से बस एक कदम दूर हैं। 🧘',
    showPayment: true,
    requiresContactForm: false,
    options: [
      { label: 'Back to Main Menu', hindi_label: 'मुख्य मेनू पर वापस जाएं', nextNode: 'welcome' },
    ],
  },

  paymentNodeRcpcod: {
    message: 'Great! You are one step away from starting your journey. 🧘',
    hindi_message: 'बढ़िया! आप अपनी journey शुरू करने से बस एक कदम दूर हैं। 🧘',
    showPayment: true,
    requiresContactForm: true,
    options: [
      { label: 'Back to Main Menu', hindi_label: 'मुख्य मेनू पर वापस जाएं', nextNode: 'welcome' },
    ],
  },

  // ─── RESPONSE NODES ──────────────────────────────────────────────────────────

  formSubmitResponse: {
    message: 'Thank you! 🙏 Details received. Please proceed to complete your payment below.',
    hindi_message: 'धन्यवाद! 🙏 आपकी जानकारी मिल गई। कृपया नीचे payment करें।',
    options: [],
  },

  formSubmitThankYou: {
    message:
      'Thank you! 🙏 Our team will reach out to you soon. Is there anything else I can help you with?',
    hindi_message: 'धन्यवाद! 🙏 हमारी टीम जल्द आपसे संपर्क करेगी। क्या मैं और कुछ मदद कर सकता हूँ?',
    options: [
      { label: 'Back to Main Menu', hindi_label: 'मुख्य मेनू पर वापस जाएं', nextNode: 'welcome' },
    ],
  },

  // ─── COURSE NODES ────────────────────────────────────────────────────────────

  showCoursesrcpcod: {
    message: 'Here are our latest courses that might interest you:',
    hindi_message: 'यहाँ हमारे नए कोर्स हैं जो आपके काम आ सकते हैं:',
    showCourses: true,
    course_category_id: 227,
    skipToPayment: true,
    options: [
      { label: 'Back to main menu', hindi_label: 'मुख्य मेनू पर वापस जाएं', nextNode: 'welcome' },
    ],
  },

  showCourseswlc: {
    coursesText: 'Here are our latest courses that might interest you:',
    hindi_coursesText: 'यहाँ हमारे नए कोर्स हैं जो आपके काम आ सकते हैं:',
    videoText: 'Check out this video:',
    hindi_videoText: 'यह वीडियो देखें:',
    video: '7tfwGYuElaI',
    showCourses: true,
    course_category_id: 150,
    skipToPayment: false,
  },

  showCourseshic: {
    message: 'Here are our latest courses that might interest you:',
    hindi_message: 'यहाँ हमारे नए कोर्स हैं जो आपके काम आ सकते हैं:',
    showCourses: true,
    videoText: 'Check out this video:',
    hindi_videoText: 'यह वीडियो देखें:',
    video: '0-c1SbUO3P4',
    course_category_id: 151,
    skipToPayment: false,
  },

  showCoursesli: {
    message: 'Here are our latest courses that might interest you:',
    hindi_message: 'यहाँ हमारे नए कोर्स हैं जो आपके काम आ सकते हैं:',
    showCourses: true,
    course_category_id: 226,
    videoText: 'Check out this video:',
    hindi_videoText: 'यह वीडियो देखें:',
     video: '0-c1SbUO3P4',
    skipToPayment: false,
  },

  // ─── HEALTH FLOW ─────────────────────────────────────────────────────────────

  askHealthIssues: {
    message: 'Do you have any health issues that we should know about?',
    hindi_message: 'क्या आपको कोई स्वास्थ्य समस्या है जो हमें पता होनी चाहिए?',
    options: [
      { label: 'Yes', hindi_label: 'हाँ', nextNode: 'healthIssuesList' },
      { label: 'No', hindi_label: 'नहीं', nextNode: 'noHealthIssueForm' },
    ],
  },

  healthIssuesList: {
    message: 'Please select your health issue from the list below:',
    hindi_message: 'कृपया नीचे दी गई list से अपनी समस्या चुनें:',
    options: [
      {
        label: 'Severe Back Pain / Neck Pain',
        hindi_label: 'कमर दर्द / गर्दन दर्द',
        nextNode: 'healthIssueResponse',
      },
      {
        label: 'Slip Disc / Sciatica',
        hindi_label: 'Slip Disc / Sciatica',
        nextNode: 'healthIssueResponse',
      },
      {
        label: 'Ligament Injuries / Meniscus Tear',
        hindi_label: 'नस की चोट / Meniscus Tear',
        nextNode: 'healthIssueResponse',
      },
      {
        label: 'Cartilage Decrease',
        hindi_label: 'Cartilage कमजोर होना',
        nextNode: 'healthIssueResponse',
      },
      {
        label: 'Arthritis (All types) / Uric Acid',
        hindi_label: 'गठिया / Uric Acid',
        nextNode: 'healthIssueResponse',
      },
      {
        label: 'Cervical / Migraine',
        hindi_label: 'Cervical / माइग्रेन',
        nextNode: 'healthIssueResponse',
      },
      {
        label: 'PCOD / PCOS / Uterus Fibroid / Cyst',
        hindi_label: 'PCOD / PCOS / Uterus Fibroid / Cyst',
        nextNode: 'healthIssueResponse',
      },
      {
        label: 'Ulcerative Colitis / IBD / IBS',
        hindi_label: 'Ulcerative Colitis / IBD / IBS',
        nextNode: 'healthIssueResponse',
      },
      {
        label: 'Depression and Anxiety',
        hindi_label: 'Depression and Anxiety',
        nextNode: 'healthIssueResponse',
      },
      {
        label: 'Skin Issues (Psoriasis, Eczema)',
        hindi_label: 'त्वचा की समस्या (Psoriasis, Eczema)',
        nextNode: 'healthIssueResponse',
      },
      {
        label: 'None of the above',
        hindi_label: 'ऊपर की सभी नहीं',
        nextNode: 'healthIssueResponse',
      },
      { label: 'Back to Main Menu', hindi_label: 'मुख्य मेनू पर वापस जाएं', nextNode: 'welcome' },
    ],
  },

  healthIssueResponse: {
    message: `We care about your health! Since Weight Loss classes are high-intensity, they might increase your pain/issue. For your safety and better recovery, we strongly recommend our Therapeutic Health classes. They are gentle, effective, and designed specially for you!`,
    hindi_message: `हम आपकी सेहत की परवाह करते हैं! Weight Loss classes काफी intense होती हैं जिससे आपकी तकलीफ बढ़ सकती है। आपकी सुरक्षा के लिए हम आपको हमारी Therapeutic Health classes लेने की सलाह देते हैं। ये classes आपके लिए specially बनाई गई हैं!`,
    showCourses: true,
    video: '0-c1SbUO3P4',
    course_category_id: 151,
    skipToPayment: false,
    options: [
      { label: 'Back to main menu', hindi_label: 'मुख्य मेनू पर वापस जाएं', nextNode: 'welcome' },
    ],
  },

  // ─── MISC ────────────────────────────────────────────────────────────────────

  thankyouMessage: {
    message: 'Thank you for chatting with us! Feel free to come back anytime. Have a great day! 😊',
    hindi_message: 'हमसे बात करने के लिए धन्यवाद! कभी भी वापस आएं। आपका दिन अच्छा रहे! 😊',
    options: [],
  },

  videoHelp: {
    message: "Here's a helpful tutorial video:",
    hindi_message: 'यहाँ एक helpful tutorial video है:',
    video: 'dQw4w9WgXcQ',
    options: [
      { label: 'That was helpful!', hindi_label: 'यह मददगार था!', nextNode: 'helpful' },
      { label: 'I need more help', hindi_label: 'मुझे और मदद चाहिए', nextNode: 'moreHelp' },
    ],
  },

  courseInfo: {
    message:
      'Our courses are designed by industry experts and include lifetime access, certificates of completion, and 24/7 support. Would you like to see more courses or enroll in one?',
    hindi_message:
      'हमारे कोर्स experts ने बनाए हैं और इनमें lifetime access, certificate और 24/7 support मिलता है। क्या आप और कोर्स देखना चाहते हैं?',
    options: [
      { label: 'Show me more courses', hindi_label: 'और कोर्स दिखाएं', nextNode: 'showCourses' },
      { label: 'How do I enroll?', hindi_label: 'Enroll कैसे करें?', nextNode: 'enrollmentInfo' },
      { label: 'Back to main menu', hindi_label: 'मुख्य मेनू पर वापस जाएं', nextNode: 'welcome' },
    ],
  },

  enrollmentInfo: {
    message:
      "To enroll in a course:\n1. Browse available courses\n2. Click on the course you're interested in\n3. Click 'Enroll Now'\n4. Complete the payment process\n\nWould you like to see available courses?",
    hindi_message:
      "कोर्स में join करने के लिए:\n1. उपलब्ध कोर्स देखें\n2. जो कोर्स पसंद हो उस पर click करें\n3. 'Enroll Now' पर click करें\n4. Payment करें\n\nक्या आप कोर्स देखना चाहते हैं?",
    options: [
      { label: 'Yes, show courses', hindi_label: 'हाँ, कोर्स दिखाएं', nextNode: 'showCourses' },
      {
        label: 'Tell me about payment',
        hindi_label: 'Payment के बारे में बताएं',
        nextNode: 'paymentInfo',
      },
      { label: 'Back to main menu', hindi_label: 'मुख्य मेनू पर वापस जाएं', nextNode: 'welcome' },
    ],
  },

  paymentInfo: {
    message:
      'We accept multiple payment methods including credit/debit cards, UPI, net banking, and wallets. All transactions are secure and encrypted.',
    hindi_message:
      'हम credit/debit card, UPI, net banking और wallets से payment लेते हैं। सभी transactions पूरी तरह safe हैं।',
    options: [
      { label: 'View courses', hindi_label: 'कोर्स देखें', nextNode: 'showCourses' },
      { label: 'Back to main menu', hindi_label: 'मुख्य मेनू पर वापस जाएं', nextNode: 'welcome' },
    ],
  },

  contentInfo: {
    message:
      "Our courses include video lectures, downloadable resources, quizzes, assignments, and live Q&A sessions. You'll also get lifetime access to all course materials.",
    hindi_message:
      'हमारे कोर्स में video lectures, downloadable resources, quizzes, assignments और live Q&A sessions हैं। साथ ही आपको सभी materials का lifetime access मिलेगा।',
    options: [
      { label: 'Browse courses', hindi_label: 'कोर्स देखें', nextNode: 'showCourses' },
      { label: 'Back to main menu', hindi_label: 'मुख्य मेनू पर वापस जाएं', nextNode: 'welcome' },
    ],
  },

  helpful: {
    message: "Great! I'm glad I could help. Is there anything else you'd like to know?",
    hindi_message: 'बढ़िया! खुशी है कि मैं मदद कर सका। क्या और कुछ जानना चाहते हैं?',
    options: [
      {
        label: 'View available courses',
        hindi_label: 'उपलब्ध कोर्स देखें',
        nextNode: 'showCourses',
      },
      {
        label: 'Watch another tutorial',
        hindi_label: 'एक और tutorial देखें',
        nextNode: 'videoHelp',
      },
      { label: "No, that's all", hindi_label: 'नहीं, बस इतना ही', nextNode: 'goodbye' },
    ],
  },

  moreHelp: {
    message: 'I understand. Would you like to browse our courses or talk to a human agent?',
    hindi_message: 'समझ गया। क्या आप कोर्स देखना चाहते हैं या किसी से बात करना चाहते हैं?',
    options: [
      { label: 'Browse courses', hindi_label: 'कोर्स देखें', nextNode: 'showCourses' },
      { label: 'Talk to an agent', hindi_label: 'किसी से बात करें', nextNode: 'connectAgent' },
      { label: 'Back to main menu', hindi_label: 'मुख्य मेनू पर वापस जाएं', nextNode: 'welcome' },
    ],
  },

  connectAgent: {
    message:
      "I'll connect you with a human agent. Please click the phone icon at the top right to call us, or continue browsing our courses while you wait.",
    hindi_message:
      'मैं आपको हमारी team से connect कर रहा हूँ। ऊपर दाईं तरफ phone icon पर click करें, या तब तक कोर्स देखते रहें।',
    options: [
      {
        label: 'View courses meanwhile',
        hindi_label: 'तब तक कोर्स देखें',
        nextNode: 'showCourses',
      },
      { label: 'Back to main menu', hindi_label: 'मुख्य मेनू पर वापस जाएं', nextNode: 'welcome' },
    ],
  },

  goodbye: {
    message: 'Thank you for chatting with us! Feel free to come back anytime. Have a great day! 😊',
    hindi_message: 'हमसे बात करने के लिए धन्यवाद! कभी भी वापस आएं। आपका दिन अच्छा रहे! 😊',
    options: [],
  },
};
